export { default } from './parts-table-wrapper';
